export default "__VITE_ASSET__7dfa5058__"